import { FC, PropsWithChildren, ReactNode } from 'react';
import { classNames } from 'primereact/utils';
import { Layout } from '@repo/atomic-components';
import { Header } from './Header';

type UserManagementTemplateProps = PropsWithChildren<{
  actionsPanel: ReactNode;
  withNavigation?: boolean;
}>;

export const UserManagementTemplate: FC<UserManagementTemplateProps> = ({ children, actionsPanel, withNavigation }) => {
  return (
    <Layout>
      <div
        className={classNames('bg-fletchers-gray-25 grid h-full w-full grid-cols-[minmax(0,1fr)] gap-0', {
          'grid-rows-[48px_48px_minmax(48px,auto)_1fr]': withNavigation,
          'grid-rows-[48px_minmax(48px,auto)_1fr]': !withNavigation,
        })}
      >
        {/* `relative z-[1102]` lifts the header above the page's
            sidebars so the nav stays in front while one is open.
            CreateEditUserSidebar pins its mask to `!z-[1000]`; 1102
            beats it (and any future overlay) regardless of where
            PrimeReact's ZIndexUtils lands. `relative` is required for
            `z-index` to take effect on a non-positioned element. */}
        <div className="relative z-[1102] col-span-full">
          <Header />
        </div>

        {withNavigation && <div className="col-span-full content-center">{/* <TopPageNavigation /> */}</div>}

        <div className="col-span-full">{actionsPanel}</div>

        <div className="col-span-full h-full w-full overflow-hidden">{children}</div>
      </div>
    </Layout>
  );
};
